import {makeSplitPoint} from 'plugins/react'

export default {
	label: 'Region map',
	group: 'content',
	Value: makeSplitPoint(() => import('./RegionMapSection')),
}
